(ns iris.posts.views.post-screening-options
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [iris.hench :as hench]
   [iris.subs :as subs]
   [iris.posts.subs :as posts-subs]
   [iris.posts.events :as posts-events]
  ;;  [herb.core :refer [<class]]
   [iris.styles.posts :as $posts]
   [iris.posts.views.user-btn :refer [user-btn]]
   [iris.components.simple-modal :refer [simple-modal]]
   [clojure.string :as string]))

;; TODO: turn off raid subscriptions and change hench/eid-to-shaid to eid-len-raid

(defn post-screen [scopes-input disable-in actions notes]
  (re-frame/dispatch [::posts-events/screen-create  {:disable_in disable-in
                                                     :actions actions
                                                     :scopes_input scopes-input
                                                     :priority 0
                                                     :kind "catchall"
                                                     :notes notes
                                                     :enabled true
                                                     :target_level 0}]))

(defn prep-screen-notes [id forum type action]
  (str "Created for post " id " in forum " forum " by pressing the "
       (cond
         (and (= type "ip") (= action "ban")) "\"Ban IP\" button #bannedip"
         (and (= type "ip") (= action "quarantine")) "\"Quarantine IP\" button #quarantinedip"
         (and (= type "eid") (= action "quarantine")) "\"Quarantine EID\" button #quarantinedeid"
         (and (= type "2of3") (= action "quarantine")) "\"Quarantine 2/3\" button #quarantined2of3")))

(defn append-screen-notes [default-notes extra-notes]
  (let [extra-notes (string/trim (or extra-notes ""))]
    (if (empty? extra-notes)
      default-notes
      (str extra-notes "\n" default-notes))))

(defn valid-disable-in-number? [value]
  (boolean (re-matches #"[1-9]\d*" (string/trim (or value "")))))

(defn override-disable-in [number unit]
  (str (string/trim (or number "")) " " unit))

(defn split-disable-in [disable-in]
  (let [[number unit] (string/split (or disable-in "") #"\s+")]
    {:number (or number "")
     :unit (or unit "d")}))

(defn screen-create-payload [pending extra-notes override-number override-unit]
  {:disable_in (override-disable-in override-number override-unit)
   :actions (:actions pending)
   :scopes_input (:scopes-input pending)
   :priority 0
   :kind "catchall"
   :notes (append-screen-notes (:default-notes pending) extra-notes)
   :enabled true
   :target_level 0})

(defn one-scope-pending-screen [d val action type default-disable-in actions]
  (let [id (get-in d [:id])
        forum (get-in d [:forum])]
    {:id (str action "-" type)
     :title (str (string/capitalize action) " "
                 (case type
                   "ip" "IP"
                   "eid" "cookie"
                   type))
     :scopes-input val
     :default-disable-in default-disable-in
     :default-notes (prep-screen-notes id forum type action)
     :actions actions}))

(defn two-of-three-pending-screen [d val1 val2 val3 action type default-disable-in actions]
  (let [id (get-in d [:id])
        forum (get-in d [:forum])]
    {:id (str action "-" type)
     :title "Quarantine 2/3"
     :scopes-input (str forum " AND min2(" val1 " OR " val2 " OR " val3 ")")
     :default-disable-in default-disable-in
     :default-notes (prep-screen-notes id forum type action)
     :actions actions}))

(defn create-screen
  ([e val id forum action type disable-in actions]
   (.preventDefault e)
   (let [scopes-input val
         notes (prep-screen-notes id forum type action)]
     (post-screen scopes-input disable-in actions notes)))
  ([e val1 val2 val3 id forum action type disable-in actions]
   (.preventDefault e)
   (let [scopes-input (str forum " AND min2(" val1 " OR " val2 " OR " val3 ")")
         notes (prep-screen-notes id forum type action)]
     (post-screen scopes-input disable-in actions notes))))

(defn open-pending-screen [e open-screen pending]
  (.preventDefault e)
  (reset! open-screen pending))

(defn submit-pending-screen [e open-screen pending extra-notes override-number override-unit error]
  (.preventDefault e)
  (if (valid-disable-in-number? @override-number)
    (do
      (reset! error nil)
      (let [payload (screen-create-payload pending @extra-notes @override-number @override-unit)]
        (post-screen (:scopes_input payload)
                     (:disable_in payload)
                     (:actions payload)
                     (:notes payload)))
      (reset! open-screen nil))
    (reset! error "Turn-off value must be a positive whole number.")))

(defn pending-screen-panel [open-screen pending]
  (let [{default-number :number default-unit :unit} (split-disable-in (:default-disable-in pending))]
    (reagent/with-let [extra-notes (reagent/atom "")
                       override-number (reagent/atom default-number)
                       override-unit (reagent/atom default-unit)
                       error (reagent/atom nil)
                       show-auto-note? (reagent/atom false)]
      [:div.post-screening-rule-body
       [:div.post-screening-rule-primary
        [:div.post-screening-rule-title
         [:strong (:title pending)]
         [:span.post-screening-title-separator " - "]
         [:span.post-screening-turnoff-label "turn off in"]]
        [:div.post-screening-disable-controls
         [:input#post-screening-disable-number.form-control
          {:type "text"
           :input-mode "numeric"
           :pattern "[0-9]*"
           :value @override-number
           :on-change (fn [e]
                        (reset! override-number (.. e -target -value))
                        (when @error
                          (reset! error nil)))}]
         [:select.form-control
          {:value @override-unit
           :on-change (fn [e]
                        (reset! override-unit (.. e -target -value))
                        (when @error
                          (reset! error nil)))}
          [:option {:value "d"} "days"]
          [:option {:value "w"} "weeks"]
          [:option {:value "m"} "months"]
          [:option {:value "y"} "years"]]]]
       [:div.post-screening-default
        "default - " (:default-disable-in pending)]
       (when @error
         [:div.text-danger.post-screening-error @error])
       [:div.post-screening-notes
        [:textarea#post-screening-extra-notes.form-control
         {:rows "1"
          :placeholder "Add a note (optional)..."
          :on-input (fn [e]
                      (let [el (.-target e)]
                        (reset! extra-notes (.-value el))
                        (set! (.. el -style -height) "auto")
                        (set! (.. el -style -height) (str (.-scrollHeight el) "px"))))}]]
       [:div.post-screening-footer
        [:div.post-screening-note-toggle
         [:a {:href "#"
              :on-click (fn [e]
                          (.preventDefault e)
                          (swap! show-auto-note? not))}
          (if @show-auto-note? "Hide auto note" "View auto note")]]
        [:div.post-screening-actions
         [:button.btn.btn-default
          {:type "button"
           :on-click (fn [e]
                       (.preventDefault e)
                       (reset! open-screen nil))}
          "Cancel"]
         [:button.btn.btn-danger
          {:type "button"
           :on-click (fn [e]
                       (submit-pending-screen e open-screen pending extra-notes override-number override-unit error))}
          "Create"]]]
       (when @show-auto-note?
         [:div.post-screening-default-note
          [:span.post-screening-default-note-lock "auto note: "]
          (:default-notes pending)])])))



(defn screening-status-class [ss]
  (cond (> (:n_enabled ss) 0)
        "post-screening-status-enabled"
        (> (:n_disabled ss) 0)
        "post-screening-status-disabled"
        :else
        nil))


(defn geo-loc-btn [d]
  (when-let [ip (get-in d [:author :ip])]
    [:a.btn.btn-default
     {:target "ip2location"
      :title "Lookup IP geo location at ip2location.com"
      :href (str "http://www.ip2location.com/demo/" ip)}
     [:i.glyphicon.glyphicon-globe]]))

(defn cc-btn [d pfx]
  (when-let [cc (get-in d [:author :cc])]
    (let [country (get-in d [:author :country])
          ss (re-frame/subscribe [::posts-subs/screning-status (str ":" cc)])
          css (screening-status-class @ss)]
      [:a.btn.btn-default
       {:title country
        :href (str pfx "/cc/" cc)
        :class css}
       (str ":" cc)])))

;; (defn ip-btn [d raid]
;;   (when-let [ip (get-in d [:author :ip])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title (str "IP address " ip)
;;         :href (str route-prefix "/ip/" ip)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :i_eid)}}])))

(defn ip-btn [d pfx]
  (when-let [ip (get-in d [:author :ip])]
    (let [i_eid (get-in d [:author :eid :i_eid])
          raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword i_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title (str "IP address " ip)
        :href (str pfx "/ip/" ip)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid i_eid raid-len)])))

;; (defn g_eid-btn [d raid]
;;   (when-let [g_eid (get-in d [:author :eid :g_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status g_eid])
;;           css (screening-status-class @ss)
;;           geo (get-in d [:author :geo])]
;;       [:a.btn.btn-default
;;        {:title geo
;;         :href
;;         (str route-prefix "/eid/" g_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :g_eid)}}])))

(defn g_eid-btn [d pfx]
  (when-let [g_eid (get-in d [:author :eid :g_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword g_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status g_eid])
          css (screening-status-class @ss)
          geo (get-in d [:author :geo])
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title geo
        :href (str pfx "/eid/" g_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid g_eid raid-len)])))

;; (defn c_eid-btn [d raid]
;;   (when-let [c_eid (get-in d [:author :eid :c_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "Cookie EID"
;;         :href
;;         (str route-prefix "/eid/" c_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :c_eid)}}])))

(defn c_eid-btn [d pfx]
  (when-let [c_eid (get-in d [:author :eid :c_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword c_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "Cookie EID"
        :href (str pfx "/eid/" c_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid c_eid raid-len)])))



;; (defn f_eid-btn [d raid]
;;   (when-let [f_eid (get-in d [:author :eid :f_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status f_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "BFP EID"
;;         :href
;;         (str route-prefix "/eid/" f_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :f_eid)}}])))

(defn f_eid-btn [d pfx]
  (when-let [f_eid (get-in d [:author :eid :f_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword f_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status f_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "BFP EID"
        :href (str pfx "/eid/" f_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid f_eid raid-len)])))


;; (defn d_eid-btn [d raid]
;;   (when-let [d_eid (get-in d [:author :eid :d_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status d_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "DFP EID"
;;         :href
;;         (str route-prefix "/eid/" d_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :d_eid)}}])))

(defn d_eid-btn [d pfx]
  (when-let [d_eid (get-in d [:author :eid :d_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword d_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status d_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "DFP EID"
        :href (str pfx "/eid/" d_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid d_eid raid-len)])))

;; (defn a_eid-btn [d raid]
;;   (when-let [a_eid (get-in d [:author :eid :a_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status a_eid])
;;           css (screening-status-class @ss)
;;           ua (get-in d [:author :user_agent])]
;;       [:a.btn.btn-default
;;        {:title ua
;;         :href
;;         (str route-prefix "/eid/" a_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :a_eid)}}])))

(defn a_eid-btn [d pfx]
  (when-let [a_eid (get-in d [:author :eid :a_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword a_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status a_eid])
          css (screening-status-class @ss)
          ua (get-in d [:author :user_agent])
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title ua
        :href (str pfx "/eid/" a_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid a_eid raid-len)])))

;; (defn m_eid-btn [d raid]
;;   (when-let [m_eid (get-in d [:author :eid :m_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status m_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {;; :title "Accepts MIME type: '*/*'"
;;         :href (str route-prefix "/eid/" m_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :m_eid)}}])))

(defn m_eid-btn [d pfx]
  (when-let [m_eid (get-in d [:author :eid :m_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword m_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status m_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:href (str pfx "/eid/" m_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid m_eid raid-len)])))


;; (defn l_eid-btn [d raid]
;;   (when-let [l_eid (get-in d [:author :eid :l_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status l_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {;; :title "Accepts languages: 'en-US,en;q=0.9'"
;;         :href (str route-prefix "/eid/" l_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :l_eid)}}])))

(defn l_eid-btn [d pfx]
  (when-let [l_eid (get-in d [:author :eid :l_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword l_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status l_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:href (str pfx "/eid/" l_eid)
        :class css
        :style {:min-width "35px"
                :text-align
                (if (some? raid) "center" "left")}}
       (hench/eid-len-raid l_eid raid-len)])))





(defn screening-action-class [open-screen pending btn-class]
  (if (= (:id @open-screen) (:id pending))
    (string/join " " [btn-class "active"])
    btn-class))

(defn ban-ip-btn [d open-screen]
  (when-let [ip (get-in d [:author :ip])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")
          pending (one-scope-pending-screen d
                                            (str "^" ip)
                                            "ban"
                                            "ip"
                                            "7 d"
                                            [{:action "ban"}])]
      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-ban-circle]]
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
      ;;    {:title "Ban IP address for 7 days"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (str "^" (get-in d [:author :ip]))
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "ban"
      ;;                                      "ip"
      ;;                                      "7 d"
      ;;                                      [{:action "ban"}]))}
      ;;    [:i.glyphicon.glyphicon-ban-circle]])
      [:a.btn.btn-grey-click.btn-disabled-click
       {:class (screening-action-class open-screen pending btn-class)
        :title "Ban IP address for 7 days"
        :on-click (fn [e] (open-pending-screen e open-screen pending))}
       [:i.glyphicon.glyphicon-ban-circle]])))


(defn q-ip-btn [d open-screen]
  (when-let [ip (get-in d [:author :ip])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")
          pending (one-scope-pending-screen d
                                            (str "^" ip)
                                            "quarantine"
                                            "ip"
                                            "6 m"
                                            [{:action "quarantine"
                                              :delay_min 60
                                              :delay_max 120}])]

      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-tower]]
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
      ;;    {:title "Quarantine IP for 6 months"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (str "^" (get-in d [:author :ip]))
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "quarantine"
      ;;                                      "ip"
      ;;                                      "6 m"
      ;;                                      [{:action "quarantine"
      ;;                                        :delay_min 60
      ;;                                        :delay_max 120}]))}
      ;;    [:i.glyphicon.glyphicon-tower]])


      [:a.btn.btn-grey-click.btn-disabled-click
       {:class (screening-action-class open-screen pending btn-class)
        :title "Quarantine IP for 6 months"
        :on-click (fn [e] (open-pending-screen e open-screen pending))}
       [:i.glyphicon.glyphicon-tower]])))


(defn q-cookie-btn [d open-screen]
  (when-let [c_eid (get-in d [:author :eid :c_eid])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")
          pending (one-scope-pending-screen d
                                            c_eid
                                            "quarantine"
                                            "eid"
                                            "6 m"
                                            [{:action "quarantine"
                                              :delay_min 60
                                              :delay_max 120}])]

      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-tower]]
      ;;   [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
      ;;    {:title "Quarantine cookie for 6 months"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (get-in d [:author :eid :c_eid])
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "quarantine"
      ;;                                      "eid"
      ;;                                      "6 m"
      ;;                                      [{:action "quarantine"
      ;;                                        :delay_min 60
      ;;                                        :delay_max 120}]))}
      ;;    [:i.glyphicon.glyphicon-tower]])


      [:a.btn.btn-grey-click.btn-disabled-click
       {:class (screening-action-class open-screen pending btn-class)
        :title "Quarantine cookie for 6 months"
        :on-click (fn [e] (open-pending-screen e open-screen pending))}
       [:i.glyphicon.glyphicon-tower]])))


(defn q-2-of-3 [d open-screen]
  (let [c_eid (get-in d [:author :eid :c_eid])
        f_eid (get-in d [:author :eid :f_eid])
        d_eid (get-in d [:author :eid :d_eid])
        forum (get-in d [:forum])

        ss-c_eid (re-frame/subscribe [::posts-subs/screning-status c_eid])
        ss-f_eid (re-frame/subscribe [::posts-subs/screning-status f_eid])
        ss-d_eid (re-frame/subscribe [::posts-subs/screning-status d_eid])
        ss-forum (re-frame/subscribe [::posts-subs/screning-status forum])

        enabled? (and (> (:n_enabled @ss-c_eid) 0)
                      (> (:n_enabled @ss-f_eid) 0)
                      (> (:n_enabled @ss-d_eid) 0)
                      (> (:n_enabled @ss-forum) 0))

        btn-class (if enabled? "btn-default" "btn-danger")
        pending (two-of-three-pending-screen d
                                             c_eid
                                             f_eid
                                             d_eid
                                             "quarantine"
                                             "2of3"
                                             "6 m"
                                             [{:action "quarantine"
                                               :delay_min 60
                                               :delay_max 120}])]


    ;; (if enabled?
    ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
    ;;    {:style {:cursor "auto"}}
    ;;    [:i.glyphicon.glyphicon-tower]
    ;;    " ⅔\n\t\t\t"]
    ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
    ;;    {:title (str "Quarantine 2 out of 3 (cookie, BFP, DFP) in forum " (get-in d [:forum]))
    ;;     :on-click (fn [e] (create-screen e
    ;;                                      (get-in d [:author :eid :c_eid])
    ;;                                      (get-in d [:author :eid :f_eid])
    ;;                                      (get-in d [:author :eid :d_eid])
    ;;                                      (get-in d [:id])
    ;;                                      (get-in d [:forum])
    ;;                                      "quarantine"
    ;;                                      "2of3"
    ;;                                      "6 m"
    ;;                                      [{:action "quarantine"
    ;;                                        :delay_min 60
    ;;                                        :delay_max 120}]))}
    ;;    [:i.glyphicon.glyphicon-tower]
    ;;    " ⅔\n\t\t\t"])


    [:a.btn.btn-grey-click.btn-disabled-click
     {:class (screening-action-class open-screen pending btn-class)
      :title (str "Quarantine 2 out of 3 (cookie, BFP, DFP) in forum " (get-in d [:forum]))
      :on-click (fn [e] (open-pending-screen e open-screen pending))}
     [:i.glyphicon.glyphicon-tower]
     " ⅔\n\t\t\t"]))


(defn post-screening-options
  ([d roles] (post-screening-options d roles ""))
  ([d roles pfx]
   (reagent/with-let [open-screen (reagent/atom nil)]
     (let [;; This subscription was unused in this function before the refactor.
           ;; Leave it disabled while verifying behavior, then remove it entirely if nothing depends on it.
           ;; raid @(re-frame/subscribe [::posts-subs/fb-data :raid (keyword (:id d))])
           mobile @(re-frame/subscribe [::subs/mobile])
           screener (contains? roles "screener")
           tracker (contains? roles "tracker")
           by-staff (true? (get-in d [:author :staff]))
           uid (get-in d [:author :uid])
           show-identity-buttons? (or (not by-staff) tracker)
           show-screening-actions? (and screener (not by-staff))]
       [:div.post-screening-options-wrap
        [:div.btn-group.btn-group-xs.ip-buttons
         {:role "group"
          :class ($posts/$post-screening-options mobile)}
         [:<>
          (when show-identity-buttons?
            [:<>
             [cc-btn d pfx]
             [g_eid-btn d pfx]
             [geo-loc-btn d]
             (when show-screening-actions? [ban-ip-btn d open-screen])
             [ip-btn d pfx]
             (when show-screening-actions? [q-ip-btn d open-screen])
             [c_eid-btn d pfx]
             (when show-screening-actions? [q-cookie-btn d open-screen])
             [f_eid-btn d pfx]
             [d_eid-btn d pfx]
             (when show-screening-actions? [q-2-of-3 d open-screen])
             [a_eid-btn d pfx]
             [m_eid-btn d pfx]
             [l_eid-btn d pfx]])
          (when uid
            [user-btn uid pfx by-staff])]]
        (when @open-screen
          ^{:key (:id @open-screen)}
          [simple-modal
           "Create screening rule"
           [pending-screen-panel open-screen @open-screen]
           560
           (fn [e]
             (.preventDefault e)
             (reset! open-screen nil))])]))))
